import { View, Text, StyleSheet } from '@react-pdf/renderer';
import { Course } from './types';

const styles = StyleSheet.create({
  card: {
    marginBottom: 12,
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  leftSection: {
    flex: 1,
    paddingRight: 8,
  },
  headerRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  title: {
    fontSize: 11.5,
    lineHeight: '14.5px',
    marginBottom: 2,
    color: '#CD1D8D',
    fontWeight: 400,
  },
  titleLimited: {
    maxWidth: '60%',
  },
  priceSection: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    gap: 10,
  },
  priceText: {
    fontSize: 10,
    lineHeight: '15px',
    color: '#171923',
    fontWeight: 400,
  },
  description: {
    fontSize: 10,
    lineHeight: '15px',
    marginBottom: 6,
    color: '#171923',
    fontWeight: 400,
  },
});

export function CourseCard({ course }: { course: Course }) {
  const courseCodeIsPresent = (course.code ?? '').trim() !== '';
  const titleText = courseCodeIsPresent ? `${course.code} - ${course.title}` : course.title;
  const isLongTitle = titleText.length > 40;

  return (
    <View style={styles.card} wrap={false}>
      <View style={styles.leftSection}>
        <View style={styles.headerRow}>
          <Text
            style={[
              styles.title,
              ...(isLongTitle && course.kind !== 'QUALIFICATION' ? [styles.titleLimited] : []),
            ]}
          >
            {titleText}
          </Text>

          {course.kind !== 'QUALIFICATION' && (
            <View style={styles.priceSection}>
              <Text style={styles.priceText}>${course.fullCoursePrice} Full Course</Text>
              <Text style={styles.priceText}>Duration {course.duration}</Text>
            </View>
          )}
        </View>

        <Text style={styles.description}>{course.description}</Text>
      </View>
    </View>
  );
}
